var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7279,
    cy: 12.728,
    r: 8.5,
    transform: "rotate(-45 12.7279 12.728)",
    stroke: "#4C657A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1117 9.69757L14.0812 12.728L17.1117 15.7585L16.1015 16.7686L13.0711 13.7382L10.0406 16.7686L9.03046 15.7585L12.0609 12.728L9.03046 9.69757L10.0406 8.68742L13.0711 11.7179L16.1015 8.68742L17.1117 9.69757Z",
    fill: "#4C657A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.8ab732b05d7d1744e06033bcf1fb3e8a.svg";
export { ForwardRef as ReactComponent };